var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrows/Chevron-right",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.84194926,12.8408591 L5.1690283,8.44079226 C4.94365723,8.22858181 4.94365723,7.88453509 5.1690283,7.67234728 L5.71404972,7.15915256 C5.93903607,6.94730436 6.30367409,6.94689683 6.52918942,7.15824693 L10.250012,10.6453765 L13.9708106,7.15824693 C14.1963259,6.94689683 14.5609639,6.94730436 14.7859503,7.15915256 L15.3309717,7.67234728 C15.5563428,7.88455773 15.5563428,8.22860445 15.3309717,8.44079226 L10.6580748,12.8408591 C10.4327037,13.053047 10.0673203,13.053047 9.84194926,12.8408591 Z",
    id: "Path-Copy-4",
    transform: "translate(10.250000, 10.000000) rotate(-90.000000) translate(-10.250000, -10.000000) "
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-right.8ee40b7e0b0f7dfbf8b0dbbfb74565e0.svg";